import { Col } from "react-bootstrap";

export const ProjectCard = ({
  title,
  description,
  technologies,
  imgUrl,
  projectUrl,
}) => {
  return (
    <Col xs={12} sm={6} lg={4}>
      <a
        href={projectUrl}
        style={{ textDecoration: "none", color: "white", display: "block" }}
        target="_blank"
        rel="noreferrer"
      >
        <div className="proj-imgbx">
          <img
            src={imgUrl}
            style={{ aspectRatio: "15/11", objectFit: "cover" }}
            alt={title}
          />
          <div className="proj-txtx">
            <h5>{title}</h5>
            <span>{description}</span>
            <br />
            <span className="proj-tech-text">{technologies}</span>
          </div>
        </div>
        <div className="proj-caption">
          <h5>{title}</h5>
          <p>{description}</p>
          <span className="proj-caption-tech">{technologies}</span>
        </div>
      </a>
    </Col>
  );
};
